import { combineReducers } from 'redux'

import record from './record'

export default combineReducers({ record })
